import createCachedSelector from 're-reselect';
import {createSelector} from 'reselect';
import {RootState} from '../../rootReducer';
import {buildingsAdapter} from './adapters';

export const {
  selectById: getBuildingById,
  selectIds: getBuildingIds,
  selectEntities: getBuildingEntities,
  selectAll: getAllBuildings,
  selectTotal: getTotalBuildings,
} = buildingsAdapter.getSelectors((state: RootState) => state.data.buildings);

export const getIsLoadingBuildings = (state: RootState) => state.data.buildings.loadingStatus === 'Loading';
export const getIsBuildingsLoaded = (state: RootState) => state.data.buildings.loadingStatus === 'Loaded';

export const getDefaultBuildingId = createSelector(
  getBuildingIds,
  (state: RootState) => state.data.user.user.defaultBuildingId,
  (buildingIds, defaultBuildingId) => {
    if (buildingIds.length === 1) {
      return buildingIds[0].toString();
    } else {
      return defaultBuildingId;
    }
  },
);

export const getDefaultBuilding = createSelector(
  getBuildingEntities,
  getDefaultBuildingId,
  (buildings, buildingId) => buildings[buildingId],
);

export const getBuildingByFloorId = createCachedSelector(
  (state: RootState, floorId: string) => state.data.floors.entities[floorId],
  getBuildingEntities,
  (floor, buildingEntities) => {
    if (!floor) {
      return;
    }
    return buildingEntities[floor.buildingId];
  },
)((_, floorId) => floorId);

export const getBuildingHasFloors = createCachedSelector(getBuildingById, (building) => {
  return building ? building.floors.length > 0 : false;
})((_: RootState, buildingId) => buildingId);

export const getIsWorkspaceBookingMandatory = createSelector(getDefaultBuilding, (building) => {
  return !building?.allowWorkdayWithoutWorkspace;
});

export const getAllBuildingsWithCapacity = createSelector(getAllBuildings, (buildings) =>
  buildings.filter((building) => building.capacity > 0),
);
